import React from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import "./PageBanner.css";
import bannerBg from "../../assets/about-banner.jpg";

const PageBanner = ({ title }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x);

  // Generate breadcrumb items
  const breadcrumbs = [
    { name: "Home", path: "/" },
    ...pathnames.map((path, index) => {
      const url = `/${pathnames.slice(0, index + 1).join("/")}`;
      const name = path.charAt(0).toUpperCase() + path.slice(1).replace(/-/g, " ");
      return { name, path: url };
    }),
  ];

  return (
    <section
      className="page-banner"
      style={{ backgroundImage: `url(${bannerBg})` }}
    >
      <div className="page-banner-overlay">
        <div className="page-banner-content">
          {/* Title */}
          <h1 className="page-banner-title">{title}</h1>

          {/* Decorative Line */}
          <div className="page-banner-line"></div>

          {/* Breadcrumb - Below */}
          <nav className="page-banner-breadcrumb" aria-label="Breadcrumb">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={crumb.path}>
                {index === 0 ? (
                  <Link to={crumb.path} className="breadcrumb-link home-link">
                    <Home size={16} />
                    <span>{crumb.name}</span>
                  </Link>
                ) : (
                  <Link to={crumb.path} className="breadcrumb-link">
                    {crumb.name}
                  </Link>
                )}
                {index < breadcrumbs.length - 1 && (
                  <ChevronRight size={16} className="breadcrumb-separator" />
                )}
              </React.Fragment>
            ))}
          </nav>
        </div>
      </div>
    </section>
  );
};

export default PageBanner;